<div class="blog-home2 py-5">
  <div class="container">
    <!-- Row  -->
    <div class="row justify-content-center">
      <!-- Column -->
      <div class="col-md-8 text-center">
        <h3 class="my-3">Upcoming Events</h3>
      </div>
    </div>
    <div class="row mt-4">
      <!-- Column -->
      <div class="col-md-4 on-hover" *ngFor="let event of upcomingEvents">
        <div class="card mb-4">
          <img class="card-img-top" src="{{baseUrl}}/{{event?.event_file}}" alt="">
          <div class="date-pos bg-info-gradiant p-2 d-inline-block text-center rounded text-white position-absolute dateBadge">
            {{event?.event_date| date:'MMM'}}<span class="d-block">{{event?.event_date| date:'d'}}</span></div>
            <div class="p-4">
              <h5 class="font-weight-medium mt-3"><a href="#" class="text-decoration-none link">{{event.title}}</a></h5>
              <p class="mt-3">{{event.body}}</p>
            </div>
        </div>
      </div>
    </div>

    <!-- Row   -->
    <div class="row justify-content-center">
      <!-- Column  -->
      <div class="col-md-8 text-center">
        <h3 class="my-3">Past Events</h3>
      </div>
    </div>
    <div class="row mt-4">
       <!-- Column  -->
      <div class="col-md-4 on-hover" *ngFor="let event of pastEvents">
        <div class="card mb-4">
          <a href="#"><img class="card-img-top" src="{{baseUrl}}/{{event?.event_file}}" alt=""></a>
          <div class="date-pos bg-info-gradiant p-2 d-inline-block text-center rounded text-white position-absolute dateBadge">
            {{event?.event_date| date:'MMM'}}<span class="d-block">{{event?.event_date| date:'d'}}</span></div>
            <div class="p-4">
              <h5 class="font-weight-medium mt-3"><a href="#" class="text-decoration-none link">{{event?.title}}</a></h5>
              <p class="mt-3">{{event?.body}}</p>
            </div>
          <!-- <a href="#" class="text-decoration-none linking text-themecolor mt-2">Learn More</a> -->
        </div>
      </div>
    </div>

  </div>
</div>